
    import './styles.scoped.css';
    export default {
  "error-icon-shake-wrapper": "awsui_error-icon-shake-wrapper_14mhv_kp9ld_103",
  "warning-icon-shake-wrapper": "awsui_warning-icon-shake-wrapper_14mhv_kp9ld_104",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_14mhv_kp9ld_1",
  "error-icon-scale-wrapper": "awsui_error-icon-scale-wrapper_14mhv_kp9ld_134",
  "warning-icon-scale-wrapper": "awsui_warning-icon-scale-wrapper_14mhv_kp9ld_135",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_14mhv_kp9ld_1",
  "warning": "awsui_warning_14mhv_kp9ld_104",
  "error": "awsui_error_14mhv_kp9ld_103",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_14mhv_kp9ld_1",
  "root": "awsui_root_14mhv_kp9ld_186",
  "label": "awsui_label_14mhv_kp9ld_222",
  "info": "awsui_info_14mhv_kp9ld_236",
  "description": "awsui_description_14mhv_kp9ld_241",
  "constraint": "awsui_constraint_14mhv_kp9ld_242",
  "hints": "awsui_hints_14mhv_kp9ld_249",
  "constraint-has-validation-text": "awsui_constraint-has-validation-text_14mhv_kp9ld_250",
  "secondary-control": "awsui_secondary-control_14mhv_kp9ld_254",
  "controls": "awsui_controls_14mhv_kp9ld_258",
  "label-hidden": "awsui_label-hidden_14mhv_kp9ld_258",
  "control": "awsui_control_14mhv_kp9ld_258",
  "error__message": "awsui_error__message_14mhv_kp9ld_285",
  "warning__message": "awsui_warning__message_14mhv_kp9ld_286",
  "visually-hidden": "awsui_visually-hidden_14mhv_kp9ld_290"
};
  